import { Badge, Text } from '@mantine/core';

interface DisabledBadgeProps {
  disabled: boolean | undefined;
}

export function DisabledBadge({ disabled }: DisabledBadgeProps) {
  return disabled === true ? (
    <Badge color="red" variant="light">
      Yes
    </Badge>
  ) : disabled === false ? (
    <Badge color="gray" variant="light">
      No
    </Badge>
  ) : (
    <Text size="sm" color="dimmed">
      —
    </Text>
  );
}
